import React, { useState } from "react";
import ActionDropdown from "components/networkExplorer/common/ActionDropdown";
import ActionDropdownItem from "components/networkExplorer/common/ActionDropdownItem";
import { BillingTypes } from "components/manage/types/BillingTypes";
import AddOrUpdateExploreFees from "./AddOrUpdateExploreFees";

type Props = {
  billing: BillingTypes;
  feeTierId?: string;
};

export default function ExploreFeesActionsCell(props: Props) {
  const [actionsOpen, setActionsOpen] = useState(false);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedFeeTierId, setSelectedFeeTierId] = useState<string | undefined>();

  const toggleActions = () => setActionsOpen((prev) => !prev);

  return (
    <>
      <ActionDropdown actionsOpen={actionsOpen} actionsToggle={toggleActions}>
        <ActionDropdownItem
          handleAction={() => {
            setActionsOpen(false);
            setShowModifyModal(true);
          }}
          iconClassName="fa fa-edit"
          labelId="manage.organization.table.actions.modify"
        />
        {/* <ActionDropdownItem
          handleAction={() => setShowDeleteModal(true)}
          iconClassName="fa fa-trash-alt"
          labelId="manage.organization.table.actions.delete"
        /> */}
      </ActionDropdown>

      {showModifyModal && (
        <AddOrUpdateExploreFees
          companyId={props.billing.companyId}
          feeTierId={props.billing.productFeeTierId}
          closeModal={() => setShowModifyModal(false)}
        />
      )}
    </>
  );
}
